import { ReactElement, ReactNode } from "react";
import type { IBaseUiConfigButtonConfig } from "src/components/atomic/UiConfigButton/types";

export interface SectionActionButtonsProps {
  loanApplicationID?: string;
  userID?: string;
  token?: string;
  tabName?: string;
  sectionID: string;
  isLenderPlatform?: boolean;
  graphQLResponse?: any;
  onDataRefresh?: () => void;
  pageName?: string;
  notify: (notification: any) => void;
  nestedFieldList?: any[]; // For extracting client side inputs for Penny Drop
  itemIndex: number;
}

export enum UICONFIGBUTTON {
  API_CALL = "api_call"
}

export enum FieldIds {
  ACCOUNT_NUMBER = "account_number"
}

interface Item {
  name?: ReactNode;
  value?: ReactNode;
  button?: ReactNode;
  label?: string;
  Value?: ReactNode;
  category?: string;
  key?: string;
  id?: string;
  onClick?: (args: any) => void;
  jsonKey?: string;
  mandatory?: {};
  visible?: {
    value: string;
    isVisible: boolean;
  };
  tag?: {
    value: null;
    visible: { value: null; isVisible: boolean };
  };
  editable?: {
    value: null;
    isEditable: boolean;
  };
}

export interface IProps {
  title: ReactNode;
  items: Item[];
  action?: ReactElement;
  whiteLabelStyle?: any;
  renderUIConfig?: boolean;
  styles?: {
    heading?: string;
    keys?: string;
    keyValuePair?: string;
    values?: string;
  };
  isEditable?: boolean;
  accordion?: boolean;
  isFirstSection?: boolean;
  editableFields?: any;
  pageName: string;
  token: string;
  isLenderPlatform: boolean;
  userID: string;
  loanApplicationID: string;
  sectionID: string;
  resourceName: string;
  notify: any;
  resourceNameSingleSubmit: string;
  reload: (userID: string) => void;
  selectedCoApplicantUserID?: string;
  key?: string;
  sectionData?: any;
  onDataRefresh: () => void;
  graphQLResponse?: any;
  uiElements?: any;
  tabName: string;
  editReference?: (values: Record<string, string>) => void;
  activeTab?: string;
  isMFLLAP?: boolean;
  handleEditClick?: (item: any) => void;
  formButtons?: any;
  loanDetails?: any;
  sectionButtons?: Record<string, IBaseUiConfigButtonConfig>;
  style: { titlePadding: boolean };
  isEnach?: boolean;
  showCustomButton?: boolean;
  onCardActionClick: (btnId: string, cardDetails: any, action?: any) => void;
  isColending?: boolean;
}
